import { A05 } from 'api/U005';

export const postAttachedFile = async (userId: string, auditionId: string, filePath: string) => {
  try {
    const json = await A05(userId, auditionId, filePath);
    const response = await fetch(json.url);
    if (!response.ok) {
      throw new Error('failed to download file');
    }
    const blob = await response.blob();
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = json.fileName;
    a.click();

    return {
      response: response,
    };
  } catch (err: unknown) {
    console.error(err);
    return null;
  }
};
